import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, ElementRef, OnInit, Signal, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticsService, APP_SETTINGS, AuthService, SettingService, SpinnerService, ToastConfigService, UtilityService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';

import { Location, NgIf, NgStyle, NgFor, DatePipe } from '@angular/common';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { HandleError } from 'src/app/core/models';
import { AdminService } from '../admin/admin.service';
import { BulletinService } from '../servicebulletin/bulletin.service';
import { TriBulletinService } from '../tri-bulletins-home/tri-bulletin.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { VideosService } from '../videos/videos.service';
import { StarComponent } from '../star/star.component';
import { ShareContentComponent } from '../share-content/share-content.component';


@Component({
    selector: 'app-bulletin-detail',
    templateUrl: './bulletin-detail.component.html',
    styleUrls: ['./bulletin-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        StarComponent,
        FormsModule,
        NgStyle,
        NgFor,
        ShareContentComponent,
        DatePipe,
    ],
})
export class BulletinDetailComponent implements OnInit {

  public bulletin;
  public bulletinDetail;
  public bulletinFiles;
  public isBulletinSaved;
  // this variable is to dynamically apply css for active section in navbar
  public sectionHtmlId = '#model';
  shareContentObject = {};
  APP_SETTINGS: any;

  public screenWidth: number;
  private subscriptions: ISubscription[] = [];

  private username: string;

  public bulletinServiceError = 'Loading data. Please wait...';
  public isLoaded = false;

  @ViewChild('modalCloseButton')
  private modalCloseButtonEle: ElementRef;

  @ViewChild('bulletinContent')
  private bulletinContentDiv: ElementRef;

  public miniIcon = 'assets/images/MINI_symbol_RGB_black_30px.png';
  public bmwSmallIcon = 'assets/images/bmw_small_logo.png';
  public rolllsRoyceIcon = 'assets/images/RR_Small_Logo_Black.png';

  private bulletinType;
  page: number;
  ratingcomments: string;
  makeName: string;
  currentRate: number;
  public lineMake = APP_SETTINGS.isMINI === 'true' ? 'MINI' : APP_SETTINGS.isRollsRoyce === 'true' ? 'ROLLSROYCE' : APP_SETTINGS.isMOTORRAD === 'true' ? 'MOTORRAD' : 'BMW';


  rating: number;
  isRatingDisabled: boolean = false;
  isButtonDisabled: boolean = false;
  errorMessage: string;

  // bulletinLabel addedd for is Motorrad --Vishal
  userRoles = {};
  imgSrc = '';
  flexClass = 'flex-10';
  footerText: Signal<string> = computed(() => this.settingsService.brandSettings().copyright)

  constructor(
    private bulletinService: BulletinService,
    private triBulletinService: TriBulletinService,
    private route: ActivatedRoute,
    private location: Location,
    private spinnerService: SpinnerService,
    private utilityService: UtilityService,
    private authService: AuthService,
    private router: Router,
    public sanitizer: DomSanitizer,
    private videoService: VideosService,
    private fb: UntypedFormBuilder,
    private adminService: AdminService,
    private analyticsService: AnalyticsService,
    private userProfileService: UserProfileService,
    private toastService: ToastConfigService,
    private readonly settingsService: SettingService,
    private changeDetector: ChangeDetectorRef) { 
    this.screenWidth = this.utilityService.getScreenWidth();
    window.scrollTo(0, 0);
  }
  smoothScroll = (element) => {
    this.sectionHtmlId = element;
    document.querySelector(element).scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  shareContent(id, type, bulletinType, bulletinDisplayNumber) {
    this.shareContentObject = {
      id: id,
      type: type,
      bulletinType: bulletinType,
      bulletinDisplayNumber: bulletinDisplayNumber
    };
  }
  ngOnInit() {

    this.userRoles = JSON.parse(localStorage.getItem('USER_INFO'));

    if (this.userRoles) {
      APP_SETTINGS.isMOTORRAD = this.userRoles['isMotorrad'];
      APP_SETTINGS.isBMW = this.userRoles['isBMW'];
      APP_SETTINGS.isMINI = this.userRoles['isMini'];
      APP_SETTINGS.isRollsRoyce = this.userRoles['isRollsRoyce'];
    }
    this.APP_SETTINGS = APP_SETTINGS;
    if (APP_SETTINGS.isBMW === 'true') {
      this.imgSrc = 'assets/images/bmw_small_logo.png';
      this.flexClass = 'flex-10';
    } else if (APP_SETTINGS.isMINI === 'true') {
      this.imgSrc = 'assets/images/MINI_symbol_RGB_black_30px.png';
      this.flexClass = 'flex-15';
    }
    else if (APP_SETTINGS.isRollsRoyce === 'true') {
      this.imgSrc = 'assets/images/RR_Small_Logo_Black.png';
      this.flexClass = 'flex-15';
    }
    else if (APP_SETTINGS.isMOTORRAD === 'true') {
      this.imgSrc = 'assets/images/bmw_motorrad_logo.jpg';
      this.flexClass = 'flex-10';
    }

    this.username = this.authService.getUserName();
    const bulletinId = this.route.snapshot.paramMap.get('id');

    this.currentRate = 0;
    this.subscriptions.push(this.utilityService.shareContentPopup$.subscribe(data => {
      if (typeof data === 'boolean') {
        this.modalCloseButtonEle.nativeElement.click();
      }
    }));
    this.getQueryParams(bulletinId);
    this.spinnerService.show('bmwSpinner');
  }

  private getQueryParams(bulletinId: string): void {
    this.route.queryParams.subscribe(params => {
      this.bulletinType = params['type'];
      this.page = parseInt(params['page']);
      this.bulletinService.getBulletinInfo(bulletinId, this.bulletinType.toLowerCase()).subscribe(data => {
        this.spinnerService.hide('bmwSpinner');
        let details: any[] = data['bulletinDetail'];

        this.orderBulletinDetails(details);

        this.bulletin = data['bulletin'];
        this.bulletinFiles = data['bulletinFiles'];

        if (this.bulletinType == 'sib') {
          this.bulletinService.addBulletinToUserHistory(this.username, data.bulletin.id).subscribe();

          if (APP_SETTINGS.isAdmin === 'true') {
            this.analyticsCallAdmintrack('Service Bulletins', this.bulletin.bulletinDisplayNumber, this.username);
          }
          else {
            //Analytics Call
            this.analyticsCallDocumentType('Service Bulletins', this.bulletin.bulletinDisplayNumber);
          }
          if (APP_SETTINGS.isExternal === 'true') {
            this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
              this.analyticsCallExternalContentTypeTrack('Service Bulletins', this.bulletin.bulletinDisplayNumber, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
            });
          }
          if (APP_SETTINGS.isDealer === 'true') {
            this.analyticsService.trackDealerContentTypeLocation('Service Bulletins', this.bulletin.bulletinDisplayNumber, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
              APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription);
          }
        }

        if (this.bulletinType == 'tri') {
          this.triBulletinService.addBulletinToUserHistory(this.username, data.bulletin.id).subscribe();
          //Analytics Call
          if (APP_SETTINGS.isAdmin === 'true') {
            this.analyticsCallAdmintrack('TRI Bulletins', this.bulletin.bulletinDisplayNumber, this.username);
          }
          else {
            this.analyticsCallDocumentType('TRI Bulletins', this.bulletin.bulletinDisplayNumber);
          }
          if (APP_SETTINGS.isExternal === 'true') {
            this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
              this.analyticsCallExternalContentTypeTrack('TRI Bulletins', this.bulletin.bulletinDisplayNumber, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
            });
          }
          if (APP_SETTINGS.isDealer === 'true') {
            this.analyticsService.trackDealerContentTypeLocation('TRI Bulletins', this.bulletin.bulletinDisplayNumber, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
              APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription);
          }
        }

        this.bulletinSavedStatus(this.bulletinType.toLowerCase(), bulletinId);
        this.getBulletinRatingDetails(this.bulletin.id);

        // details.forEach(detail => {
        // detail.descriptionRich = this.sanitizer.bypassSecurityTrustHtml(detail.descriptionRich);
        // })
        this.bulletinDetail = this.sanitizeRichHTMLDetails(details);
        setTimeout(() => {
          this.isLoaded = true;
        }, 100);
        this.changeDetector.detectChanges();
      },
        error => {
          this.spinnerService.hide('bmwSpinner');
          this.bulletinServiceError = HandleError.handleAPIError(error);
        }
      )
    });
  }

  analyticsCallExternalContentTypeTrack(contentType, contentName, userAddress, userCity, userState, userZipCode) {
    this.analyticsService.trackClicksByExternalContentType(contentType, contentName, userAddress, userCity, userState, userZipCode);
  }
  analyticsCallDocumentType(contentType, contentName) {
    this.analyticsService.trackClicksByDocumentsContentTypeLineMake(contentType, contentName);
  }


  analyticsCallAdmintrack(contentType, contentName, userid) {
    this.analyticsService.trackClicksbyAdminUser(contentType, contentName, userid);
  }

  orderBulletinDetails(details) {
    for (let i = 0; i < details.length; i++) {
      if (details[i].title === 'Voulantary Recall Campaign') {
        details[i].sortingOrder = 1;
      }
      if (details[i].title === 'Recall Campaign') {
        details[i].sortingOrder = 2;
      }
      if (details[i].title === 'Service Action') {
        details[i].sortingOrder = 3;
      }
      if (details[i].title === 'Start and End Dates') {
        details[i].sortingOrder = 4;
      }
      if (details[i].title === 'Model(s)') {
        details[i].sortingOrder = 5;
      }
      if (details[i].title === 'Situation') {
        details[i].sortingOrder = 6;
      }
      if (details[i].title === 'Affected Vehicles') {
        details[i].sortingOrder = 7;
      }
      if (details[i].title === 'Cause') {
        details[i].sortingOrder = 8;
      }
      if (details[i].title === 'Correction') {
        details[i].sortingOrder = 9;
      }
      if (details[i].title === 'Procedure') {
        details[i].sortingOrder = 10;
      }
      if (details[i].title === 'Parts Information') {
        details[i].sortingOrder = 11;
      }
      if (details[i].title === 'Warranty Information') {
        details[i].sortingOrder = 12;
      }
      if (details[i].title === 'Supporting Materials') {
        details[i].sortingOrder = 13;
      }
      if (details[i].title === 'Custom') {
        details[i].sortingOrder = 14;
      }
    }

    details = details.sort((a, b) => {
      if (a['sortingOrder'] < b['sortingOrder']) {
        return -1;
      } else if (a['sortingOrder'] > b['sortingOrder']) {
        return 1;
      } else {
        return 0;
      }
    });

  }

  bulletinSavedStatus(bulletinType, bulletinId) {
    this.subscriptions.push(this.bulletinService.getBulletinData(this.username, bulletinType, bulletinId).subscribe(value => {
      this.isBulletinSaved = value['savedBulletinGroup'];
      this.spinnerService.hide('bmwSpinner');
      this.changeDetector.detectChanges();
    }));
  }

  navigateToBulletin(bulletinId: string) {
    this.router.navigate(['/bulletin', bulletinId]);
  }

  navigateBack() {
    this.location.back();
  }

  toggleSave() {
    this.spinnerService.show('bmwSpinner');
    if (!this.isBulletinSaved) {
      if (this.bulletinType === 'sib' || this.bulletinType === 'SIB') {
        //Analytics Call
        this.analyticsService.trackSavedContentByTypeLineMake('Service Bulletins', this.bulletin.bulletinDisplayNumber, 'saved');
      }
      if (this.bulletinType == 'tri' || this.bulletinType === 'TRI') {
        //Analytics Call
        this.analyticsService.trackSavedContentByTypeLineMake('TRI Bulletins', this.bulletin.bulletinDisplayNumber, 'saved');
      }

      this.subscriptions.push(this.bulletinService.saveBulletin(this.username, this.bulletinType.toLowerCase(), this.bulletin['bulletinDisplayId']).subscribe(data => {
        this.bulletinSavedStatus(this.bulletinType.toLowerCase(), this.bulletin['bulletinDisplayId']);
      },
        error => {
          this.spinnerService.hide('bmwSpinner');
        }));
    } else {
      this.subscriptions.push(this.bulletinService.unSaveBulletin(this.username, this.bulletin['id']).subscribe(data => {
        this.bulletinSavedStatus(this.bulletinType.toLowerCase(), this.bulletin['bulletinDisplayId']);
      },
        error => {
          this.spinnerService.hide('bmwSpinner');
        }));
    }
  }

  printBulletin(): void {
    let printContents, popupWindow;
    printContents = this.bulletinContentDiv.nativeElement.innerHTML;

    popupWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWindow.document.open();
    const htmlContent = `
    <html>
      <head>
        <title>${this.bulletin.bulletinDisplayNumber}_${this.bulletin.description}</title>
        <style>
        body {
          font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
        }
        .bmw-lg-bulletin-section-header{
          font-weight: bold; 
          font-size: 18px;
        }
        .print-title{
          font-weight: bold;
          font-size: 24px;
          text-align: center;
          margin-bottom: 10px;
        }
        </style>
        <link rel="stylesheet" href="bulletin-detail.component.css">
      </head>
      <body onload="window.print();window.close()">
      <div style="position: fixed;bottom: 0;
      width: 100%; background: #fff;
      text-align: center;">${this.footerText()}</div>
      <table style="width:100%">
      <tbody>
      <tr>
      <td >
      <div style="page-break-after: always;">
        ${printContents} <br />
        </div>
      </td>
      </tr>
      </tbody>
  <tfoot>
    <tr>
      <td>
      <div style="height: 20px;"></div>
      
    </td>
    </tr>
  </tfoot>
  </table>
      </body>
    </html>`;
    popupWindow.document.write(htmlContent);
    popupWindow.document.close();
  }

  isCustomContent(title: string): boolean {
    if (title != 'Legacy' &&
      title != 'Situation' &&
      title != 'Recall Campaign' &&
      title != 'Service Action' &&
      title != 'Voulantary Recall Campaign' &&
      title != 'Affected Vehicles' &&
      title != 'Correction' &&
      title != 'Model(s)' &&
      title != 'Cause' &&
      title != 'Procedure' &&
      title != 'Parts Information' &&
      title != 'Warranty Information' &&
      title != 'Supporting Materials') {
      return true;
    } else {
      return false;
    }
  }

  openVideo(videoNumber: String) {
    this.subscriptions.push(this.videoService.getVideoLinkParam(videoNumber, 'BMW').subscribe(data => {
      var url = '/playback?' + data.url;
      this.router.navigateByUrl(url);
    },
      error => {
        alert("Error opening the video link");
        this.spinnerService.hide('bmwSpinner');
      }));
  }

  ratingComponentClick(clickObj: any): void {
    this.rating = clickObj.rating;
  }
  saveRating() {
    this.errorMessage = null;
    const bulletinId = this.route.snapshot.paramMap.get('id');

    if (this.rating == null || this.rating == 0) {
      this.errorMessage = 'Please give rating to bulletin';
    } else if (this.ratingcomments == null || this.ratingcomments == '') {
      this.errorMessage = 'Please enter comments';
    } else {
      if (this.bulletinType === 'sib' || this.bulletinType === 'SIB') {
        //Analytics Call
        this.analyticsService.trackRatingByTypeLineMake('Service Bulletins', this.bulletin.bulletinDisplayNumber, 'rated');
      }
      if (this.bulletinType == 'tri' || this.bulletinType === 'TRI') {
        //Analytics Call
        this.analyticsService.trackRatingByTypeLineMake('TRI Bulletins', this.bulletin.bulletinDisplayNumber, 'rated');
      }
      this.adminService.submitBulletinRating(this.bulletin.id, this.rating, this.ratingcomments ? this.ratingcomments : "")
        .subscribe(response => { },
          error => {
            this.spinnerService.hide('bmwSpinner');
            //this.errorMessage = error.error.message;
          });
      this.toastService.popToast('Rating has been Saved');
      this.isButtonDisabled = true;
    }

  }

  getBulletinRatingDetails(bulletinId) {
    let dispflag = true;
    this.adminService.getBulletinRatingDetails(bulletinId).subscribe(data => {
      if (data) {
        this.spinnerService.hide('bmwSpinner');
        this.rating = data['bulletinId'];
        this.ratingcomments = data['comment'];
        if (this.rating > 0) {
          this.isRatingDisabled = false;
          dispflag = false;
        }
      }
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        //this.errorMessage = error.error.message;
      });
    if (dispflag) {
      this.isRatingDisabled = true;
    } else {
      this.isRatingDisabled = false;
    }
  }

  public sanitizeRichHTMLDetails(bulletinDetails: any[]) {
    bulletinDetails.forEach(detail => {
      if (detail?.title === "Legacy") {
        detail.descriptionRich = this.sanitizer.bypassSecurityTrustHtml(detail?.descriptionRich);
      }
    });

    return bulletinDetails;
  }
}
